/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MoveMaterialRequestViewModel } from "../types/MoveMaterialRequestViewModel.ts";

export const moveMaterialRequestViewModelSchema = z.object({
  parentFolderId: z.number().int().nullish(),
}) as unknown as ToZod<MoveMaterialRequestViewModel>;
